import React from 'react';
import {
    IconViewLayoutGrid2x,
    IconViewLayoutGrid3x,
    IconViewLayoutGrid4x,
} from "../Profile/pages/Medios/IconosViewLayout.jsx";
import { BsList } from "react-icons/bs";
import { ChevronDown, Check } from "lucide-react";

const triggerCls =
    "flex items-center gap-1.5 px-3 h-12 rounded-lg text-sm font-medium cursor-pointer select-none " +
    "border border-base-content/20 bg-base-100 text-base-content " +
    "hover:bg-base-200 transition-colors duration-150";

const panelCls =
    "dropdown-content z-[9999] mt-1 rounded-xl shadow-xl " +
    "bg-base-100 border border-base-300 " +
    "p-1.5 w-52 flex flex-col gap-0.5";

const GridIcon = ({ mode, columns, className }) => {
    if (mode === 'list')               return <BsList className={className} />;
    if (mode === 'grid' && columns == 2) return <IconViewLayoutGrid2x className={className} />;
    if (mode === 'grid' && columns == 3) return <IconViewLayoutGrid3x className={className} />;
    if (mode === 'grid' && columns == 4) return <IconViewLayoutGrid4x className={className} />;
    return null;
};

const DropdownTipoVista = ({ options, selectedValue, onChange }) => {
    const current = options.find(
        o => o.value?.mode === selectedValue?.mode && o.value?.columns === selectedValue?.columns
    );

    return (
        <div className="dropdown">
            <label tabIndex={0} className={triggerCls}>
                <GridIcon mode={selectedValue?.mode} columns={selectedValue?.columns} className="h-4 w-4 shrink-0" />
                <span>{current?.label ?? 'Vista'}</span>
                <ChevronDown size={14} className="opacity-50 shrink-0" />
            </label>

            <ul tabIndex={0} className={panelCls}>
                {options.map((option, idx) => {
                    const isSelected =
                        option.value?.mode === selectedValue?.mode &&
                        option.value?.columns === selectedValue?.columns;
                    return (
                        <li key={`${option.value.mode}-${option.value.columns ?? 'list'}-${idx}`}>
                            <button
                                onClick={() => { onChange(option.value); document.activeElement?.blur(); }}
                                className={`flex items-center gap-2 px-3 py-2 rounded-lg text-sm w-full text-left
                                    transition-colors duration-100
                                    ${isSelected
                                        ? "bg-primary/10 text-primary font-semibold"
                                        : "text-base-content hover:bg-base-200"
                                    }`}
                            >
                                <GridIcon mode={option.value?.mode} columns={option.value?.columns} className="h-4 w-4 shrink-0" />
                                {option.label}
                                {isSelected && (
                                    <Check size={13} className="ml-auto shrink-0 text-primary" />
                                )}
                            </button>
                        </li>
                    );
                })}
            </ul>
        </div>
    );
};

export default DropdownTipoVista;
